/**
 * DashboardStatisticsRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * DashboardStatisticsRes
 */
export interface DashboardStatisticsRes {
  /** 用户总数 */
  total_users?: number
  /** 今日新增用户 */
  today_new_users?: number
  /** 本周新增用户 */
  week_new_users?: number
  /** 本月新增用户 */
  month_new_users?: number
  /** 帖子总数 */
  total_posts?: number
  /** 今日新增帖子 */
  today_new_posts?: number
  /** 本周新增帖子 */
  week_new_posts?: number
  /** 本月新增帖子 */
  month_new_posts?: number
  /** 大本营总数 */
  total_camp_groups?: number
  /** 今日新增大本营 */
  today_new_camp_groups?: number
  /** 本周新增大本营 */
  week_new_camp_groups?: number
  /** 本月新增大本营 */
  month_new_camp_groups?: number
  /** 对线群总数 */
  total_battle_groups?: number
  /** 今日新增对线群 */
  today_new_battle_groups?: number
  /** 本周新增对线群 */
  week_new_battle_groups?: number
  /** 本月新增对线群 */
  month_new_battle_groups?: number
}

/**
 * DashboardStatisticsRes Schema
 */
export const DashboardStatisticsResSchema: SchemaDefinition = {
  properties: {
    total_users: {
      description: '用户总数',
      format: 'int',
      type: 'integer',
      label: '用户总数',
    },
    today_new_users: {
      description: '今日新增用户',
      format: 'int',
      type: 'integer',
      label: '今日新增用户',
    },
    week_new_users: {
      description: '本周新增用户',
      format: 'int',
      type: 'integer',
      label: '本周新增用户',
    },
    month_new_users: {
      description: '本月新增用户',
      format: 'int',
      type: 'integer',
      label: '本月新增用户',
    },
    total_posts: {
      description: '帖子总数',
      format: 'int',
      type: 'integer',
      label: '帖子总数',
    },
    today_new_posts: {
      description: '今日新增帖子',
      format: 'int',
      type: 'integer',
      label: '今日新增帖子',
    },
    week_new_posts: {
      description: '本周新增帖子',
      format: 'int',
      type: 'integer',
      label: '本周新增帖子',
    },
    month_new_posts: {
      description: '本月新增帖子',
      format: 'int',
      type: 'integer',
      label: '本月新增帖子',
    },
    total_camp_groups: {
      description: '大本营总数',
      format: 'int',
      type: 'integer',
      label: '大本营总数',
    },
    today_new_camp_groups: {
      description: '今日新增大本营',
      format: 'int',
      type: 'integer',
      label: '今日新增大本营',
    },
    week_new_camp_groups: {
      description: '本周新增大本营',
      format: 'int',
      type: 'integer',
      label: '本周新增大本营',
    },
    month_new_camp_groups: {
      description: '本月新增大本营',
      format: 'int',
      type: 'integer',
      label: '本月新增大本营',
    },
    total_battle_groups: {
      description: '对线群总数',
      format: 'int',
      type: 'integer',
      label: '对线群总数',
    },
    today_new_battle_groups: {
      description: '今日新增对线群',
      format: 'int',
      type: 'integer',
      label: '今日新增对线群',
    },
    week_new_battle_groups: {
      description: '本周新增对线群',
      format: 'int',
      type: 'integer',
      label: '本周新增对线群',
    },
    month_new_battle_groups: {
      description: '本月新增对线群',
      format: 'int',
      type: 'integer',
      label: '本月新增对线群',
    },
  },
  type: 'object',
}
